import APIController from 'api/core-api-controller';

export const fetchAddressesApi = (paramsStr = '') => {
  const path = `${APIController.endpointApi}/addresses${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path);
};

export const createAddressApi = (obj) => {
  const path = `${APIController.endpointApi}/addresses`;
  return APIController.postCallback(path, obj);
};

export const updateAddressApi = (obj, addressId = '') => {
  const path = `${APIController.endpointApi}/addresses/${addressId}`;
  return APIController.putCallback(path, obj);
};

export const deleteAddressApi = (obj, addressId) => {
  const path = `${APIController.endpointApi}/addresses/${addressId}`;
  return APIController.deleteCallback(path, obj);
};
